import gql from 'graphql-tag'
import { ElementPartsFragment } from '../Projects/mutations'

export const PROJECT_ROOT_QUERY = gql`
  query ProjectRoot($id: ID!) {
    element(id: $id) {
      ...ElementParts
    }
  }
${ElementPartsFragment}
`

export const PROJECT_TREE_QUERY = gql`
  query ProjectTree($project_id: ID!) {
    project_tree(project_id: $project_id)
  }
`


// WEBPACK FOOTER //
// ./src/components/FinalReport/graphql.js